import { SessionIdentity, StepEvent } from '@samelogic/steps';
import _ from 'lodash';
import { WorkflowConfig } from '../..';
import { StepContainer } from '../../workflows/Steps';
import { IdentitySourceManager } from '../identitysource/IdentitySourceManager';
import stringify from 'json-stringify-safe';

interface StepEventBody {
  identity?: SessionIdentity;
  project?: ProjectProperties;
  event: StepEvent;
  workflowId?: string;
  instanceId: string;
}

interface ProjectProperties {
  envId?: string;
  projectId?: string;
  orgId?: string;
}

export class EventLogger {
  private _identity?: SessionIdentity = undefined;
  private _project?: ProjectProperties = undefined;
  private _workflow?: WorkflowConfig = undefined;
  private identitySourceMan?: IdentitySourceManager;

  constructor(private _endpoint?: string) {}

  setWorkflowConfig(config: WorkflowConfig) {
    this._workflow = config;
    this.identitySourceMan = new IdentitySourceManager(config.identitySource);
  }

  setSessionIdentity(identity: SessionIdentity) {
    this._identity = identity;
  }

  setProject(project: ProjectProperties) {
    this._project = project;
  }

  async logStepEvent(evt: StepEvent, container: StepContainer) {
    if (!this._endpoint) return;

    const sourcedIdentity = this.identitySourceMan?.fetchIdentityData(window);

    try {
      const body: StepEventBody = {
        identity: _.merge(this._identity, sourcedIdentity),
        project: this._project,
        event: evt,
        workflowId: this._workflow ? this._workflow.id : undefined,
        instanceId: container.instanceId
      };

      await fetch(this._endpoint, {
        method: 'post',
        mode: 'cors',
        body: stringify(body),
        headers: {
          'Content-Type': 'application/json'
        }
      });
    } catch (error) {
      console.log(`Event Log Error:`, error);
    }
  }
}
